import { render, staticRenderFns } from "./SaveButtons.vue?vue&type=template&id=8f0b8a9c&"
import script from "./SaveButtons.vue?vue&type=script&lang=js&"
export * from "./SaveButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.STrKMrcDoQYq/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f0b8a9c')) {
      api.createRecord('8f0b8a9c', component.options)
    } else {
      api.reload('8f0b8a9c', component.options)
    }
    module.hot.accept("./SaveButtons.vue?vue&type=template&id=8f0b8a9c&", function () {
      api.rerender('8f0b8a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/SaveButtons.vue"
export default component.exports